// Imports


// Plugins
const plugins = [{
  location: "/Users/work/Desktop/interactives-inspector/interactives-inspector",
  plugins: [],
  hooks: {}
}]

// Export em!
export default plugins